var _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogosTwitterIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_22_523",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 48,
    height: 48
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 8,
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_22_523)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 8,
    width: 32,
    height: 32,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.08 0H1.92C0.858 0 0 0.858 0 1.92V46.08C0 47.142 0.858 48 1.92 48H46.08C47.142 48 48 47.142 48 46.08V1.92C48 0.858 47.142 0 46.08 0ZM36.918 17.382C36.936 17.664 36.936 17.958 36.936 18.246C36.936 27.054 30.228 37.2 17.97 37.2C14.19 37.2 10.686 36.102 7.734 34.212C8.274 34.272 8.79 34.296 9.342 34.296C12.462 34.296 15.33 33.24 17.616 31.452C14.688 31.392 12.228 29.472 11.388 26.832C12.414 26.982 13.338 26.982 14.394 26.712C12.8864 26.4057 11.5312 25.5869 10.5589 24.3947C9.58655 23.2025 9.05692 21.7104 9.06 20.172V20.088C9.942 20.586 10.98 20.892 12.066 20.934C11.1531 20.3256 10.4043 19.5013 9.88627 18.5342C9.36819 17.5671 9.09674 16.4871 9.096 15.39C9.096 14.148 9.42 13.014 10.002 12.03C11.6754 14.09 13.7636 15.7749 16.1308 16.975C18.498 18.1751 21.0912 18.8637 23.742 18.996C22.8 14.466 26.184 10.8 30.252 10.8C32.172 10.8 33.9 11.604 35.118 12.9C36.624 12.618 38.064 12.054 39.348 11.298C38.85 12.84 37.806 14.142 36.42 14.964C37.764 14.82 39.06 14.448 40.26 13.926C39.354 15.258 38.22 16.44 36.918 17.382Z",
    fill: "#1D9BF0"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogosTwitterIcon);
export default __webpack_public_path__ + "static/media/logos_twitter-icon.223cb51e1a398c0481c3e920b34946ec.svg";
export { ForwardRef as ReactComponent };